import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { User } from './model/entity-model';

@Injectable()
export class AuthService {
    static config = {
        client_id: 'brewersClient',
        accessName: 'access_token',
        refreshName: 'refresh_token',
    };
    loggedIn: boolean;

    private userSubject: BehaviorSubject<User>;
    public get currentUser(): User {
        return this.userSubject.value;
    }

    private refreshTokenTimeout: any;

    constructor(private http: HttpClient, private router: Router) {
        this.userSubject = new BehaviorSubject<User>(null);
    }

    login(username: string, password: string) {
        return this.http.post<any>(`${environment.serviceName}/users/authenticate`, { username, password }, { withCredentials: true }).pipe(
            map(user => {
                this.setUser(user);
            })
        );
    }

    logout() {
        this.http.post<any>(`${environment.serviceName}/users/revoke-token`, {}, { withCredentials: true }).subscribe();
        this.stopRefreshTokenTimer();
        this.userSubject.next(null);
        this.router.navigate(['/login']);
    }

    private setUser(user: any) {
        this.userSubject.next(user);
        this.startRefreshTokenTimer();
        this.loggedIn = true;
        return user;
    }

    private startRefreshTokenTimer() {
        // parse json object from base64 encoded jwt token
        const jwtToken = JSON.parse(atob(this.currentUser.jwtToken?.split('.')[1]));

        // set a timeout to refresh the token a minute before it expires
        const expires = new Date(jwtToken.exp * 1000);
        const timeout = expires.getTime() - Date.now() - 60 * 1000;
        this.refreshTokenTimeout = setTimeout(() => this.refreshToken().subscribe(), timeout);
    }

    refreshToken() {
        return this.http.post<any>(`${environment.serviceName}/users/refresh-token`, {}, { withCredentials: true }).pipe(
            map(user => {
                return this.setUser(user);
            })
        );
    }

    private stopRefreshTokenTimer() {
        clearTimeout(this.refreshTokenTimeout);
    }

    hasRole(role: string) {
        const current = this.userHasRole(this.currentUser, role);
        return current;
    }

    userHasRole(user: any, role: string) {
        if (!user || !user.roles) return false;

        return user.roles.some((roleName: string) => {
            // see if user permission equals permission to check
            return role === roleName;
        });
    }
}
